import React, {Component, Fragment} from 'react'
import CountNavigator from "../components/statistics/common/CountNavigator";
import DashboardTrend from "../components/dashboard/DashboardTrend";
import DashboardCurrent from "../components/dashboard/DashboardCurrent";
import DashboardRecentEntry from "../components/dashboard/DashboardRecentEntry";
import {connect} from "react-redux";
import {setInit, setMinDate} from "../actions/statistics/statisticsActions";
import {checkAndGetMaintenanceMsg, getBlogCreatedDate} from "../components/statistics/common/CommonHelper";
import Maintenance from "../components/statistics/common/Maintenance";
import If from "../components/common/control/If";

@connect(state => ({state}), dispatch => {
  return ({
    handleSetInit() {
      dispatch(setInit())
    },
    handlerSetMinDate(minDate) {
      dispatch(setMinDate(minDate))
    },
  });
})
class DashboardApp extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {lastUpdateTime: null};
    this.maintenanceMsg = checkAndGetMaintenanceMsg();
    this.defindedMinDate = "2018-01-01";
  }

  componentDidMount() {
    this.props.handleSetInit();
    this.setBlogCreatationDate();
  }

  // CountNavigator 마지막 갱신시간
  handleSetCountNavigatorLastUpdateTime = (lastUpdateTime) => {
    this.setState({
      lastUpdateTime: lastUpdateTime
    })
  };

  // 블로그 최초 생성일
  setBlogCreatationDate() {
    const minDate = getBlogCreatedDate();
    this.props.handlerSetMinDate(minDate);
  }

  render() {
    const {lastUpdateTime} = this.state;
    const isMaintenance = this.maintenanceMsg !== null;

    return (
      <div className="inner_article">
        <h2 id="kakaoBody" className="screen_out">티스토리 관리센터 본문</h2>
        <h3 className="screen_out">블로그 관리센터 홈</h3>

        <If condition={lastUpdateTime != null}><span className="info_rate_date">{lastUpdateTime} 기준</span></If>

        <div className="blog_top">
          <If condition={isMaintenance}><Maintenance className="box_blog box_inspect" msg={this.maintenanceMsg}/></If>{/*점검페이지*/}
          <If condition={!isMaintenance}>
            <Fragment>
              <CountNavigator useLinkBlogStatistics={true} handleSetCountNavigatorLastUpdateTime={this.handleSetCountNavigatorLastUpdateTime}/>
              <DashboardTrend/>
              <DashboardCurrent/>
              <DashboardRecentEntry/>
            </Fragment>
          </If>
        </div>
      </div>
    )
  }
}

export default DashboardApp
